import angular from 'angular';

const services = angular.module('applicationModule.webElementsServices', []);

services.factory('Webelements', ['WebelementsAPI', function (WebelementsAPI) {
    'use strict';

    return {
        all: (appId, moduleId) =>
            WebelementsAPI.all(appId, moduleId).then(response => response.data),

        get: id => WebelementsAPI.get(id),

        save: (data, images, editMode) =>
            WebelementsAPI.store(data, images, editMode),

        remove: (id, module_id) =>
            WebelementsAPI.remove(id, module_id),

        create: params =>
            WebelementsAPI.create(params).then(response => response.data),

        changeOrder: data =>
            WebelementsAPI.changeOrder(data),

        autocomplete: (module_id, from, search) =>
            WebelementsAPI.autocomplete(module_id, from, search),

        autocompletePerType: (module_id, from, type, search) =>
            WebelementsAPI.autocompletePerType(module_id, from, type, search)
    };
}]);


services.service('WebelementsAPI', ['$http', 'AppsoupAPI', 'Upload', function ($http, AppsoupAPI, Upload) {
    'use strict';

    const API_URL = `${AppsoupAPI.API_URL}/app/web-elements/`;

    const checkFiles = images => {
        const files = [];
        const names = [];
        angular.forEach(images, (val, key) => {
            if (angular.isDefined(val)) {
                files.push(val);
                names.push(key);
            }
        });
        return {files, names};
    };

    this.all = (appId, moduleId) =>
        $http.get(API_URL, {params: {application_id: appId, module_id: moduleId}});

    this.get = id => $http.get(`${API_URL}${id}`);

    this.store = (data, images, editMode) => {
        let files;
        if (editMode) {
            if (angular.isDefined(images) && Object.keys(images).length > 0) {
                files = checkFiles(images);
                const newFields = angular.extend(data, {_method: 'PUT'});

                return Upload.upload({
                    url: `${API_URL}${data.id}`,
                    method: 'POST',
                    sendObjectsAsJsonBlob: false,
                    fields: newFields,
                    file: files.files,
                    fileFormDataName: files.names
                });
            } else {
                return $http.put(`${API_URL}${data.id}`, data);
            }
        } else {
            if (angular.isDefined(images) && Object.keys(images).length > 0) {
                files = checkFiles(images);

                return Upload.upload({
                    url: API_URL,
                    method: 'POST',
                    sendObjectsAsJsonBlob: false,
                    fields: data,
                    file: files.files,
                    fileFormDataName: files.names
                });
            } else {
                return $http.post(API_URL, data);
            }
        }
    };

    this.remove = (id, moduleId) =>
        $http.delete(`${API_URL}${id}`, {params: {module_id: moduleId}});

    this.create = params =>
        $http.get(`${API_URL}create`, {params});

    this.changeOrder = data =>
        $http.post(`${API_URL}change-order/`, data);

    this.autocomplete = (module_id, from, search) =>
        $http.get(`${API_URL}autocomplete/${module_id}/${from}/${search}`);

    this.autocompletePerType = (module_id, from, type, search) =>
        $http.get(`${API_URL}autocomplete-per-type/${module_id}/${from}/${type}/${search}`);
}]);

export default services;